(function($, undefined) {
	
	'use strict';
    var customLinksBtn;
    var customLinksPageBtn;
    var customLinksPageSaveBtn;
    var addCustomLinksBtn;
    var delCustomLinksBtn;

    var openCustomLinks = function(){
        var id = $(this).attr("data-popup-id");
        openWindow(id, true);
        
    };
    
    var selectCustomLink = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var ctn = t.closest(".windowMainContainer").find(".admin-section-links-chosen-ctn");
        if(t.hasClass("selected")){
            t.removeClass("selected");
            ctn.find(".admin-custom-links-ctn[data-id = '"+id+"']").remove();
        } else{
            t.addClass("selected");    
            createLink(ctn, id, t.attr("data-name"), t.attr("data-mainTag"));
        }
    };
    
    var createLink = function(ctn, id, text, href){
        var link = $("#link-admin-copy").children().clone("true");
        link.attr("data-id", id);
        link.find(".admin-custom-selected-links").attr("href", href);
        link.find(".admin-custom-selected-links").html(text);
        
        ctn.append(link);
    };
    
    var addCustomLink = function(){
        var t = $(this);
        var form = t.closest(".admin-page-name-external");
        var ctn = t.closest(".windowMainContainer").find(".admin-section-links-chosen-ctn");
        
        var name = form.find("input[name='customText']").val();
        var link = form.find("input[name='customLink']").val();
        
        if(name.trim() !== '' && link.trim() !== ''){
            createLink(ctn,"", name, link);
            form.find("input[name='customText']").val("");
            form.find("input[name='customLink']").val("");
        }
        
    };
    
    var saveCustomLinks = function(){
        var ids = "";
        var key = $(this).attr("data-label");
        var windowId = $(this).attr("data-window-id");
        // var langs = ($(this).attr("data-langs") !== undefined && $(this).attr("data-langs") !== "") ? $(this).attr("data-langs") : ["fr"];
        var lang = ($(this).attr("data-lang") !== undefined && $(this).attr("data-lang") !== "") ? $(this).attr("data-lang") : fr;
        
        $("#"+windowId+" .admin-section-custom-choice .admin-custom-links-ctn").each(function(){
            var id = $(this).attr("data-id");
            if(id !== ''){
                ids += $(this).attr("data-id")+",";
            }
            else{
                ids += $(this).find('.admin-custom-selected-links').attr("href")+"~!~"+$(this).find('.admin-custom-selected-links').html()+",";                
            }
        });
        
        // for(var i = 0 ; i < langs.length ; i++){
            labels.save(key, ids, lang, function() {
                // if(i === langs.length){
                    closeWindow(windowId);
                // }
            });
        // }
        
    };
    
    var initDraggable = function(){
        $(".admin-section-links-chosen-ctn").sortable({
            connectWith: ".admin-section-links-chosen-ctn",
            handle: ".admin-dragger"

        }).disableSelection(); 
        
    };

    var delCustomLink = function(){
        var t = $(this);
        var ctn = t.closest(".admin-custom-links-ctn");
        var id = ctn.attr("data-id");
        var win = t.closest(".windowMainContainer");
        if(id !== '' && win.find(".admin-page-name.selected[data-id = "+id+"]").length !== 0){
            win.find(".admin-page-name.selected[data-id = "+id+"]").removeClass("selected");
        }
        ctn.remove();
    };

	var init = function (page) {
		var currPage = $(page);
        
        customLinksBtn = $(".choose-custom-links");
        customLinksBtn.on("click", openCustomLinks);
        
        customLinksPageBtn = $(".admin-page-name");
        customLinksPageBtn.on("click", selectCustomLink);
        
        addCustomLinksBtn = $(".add-custom-link");
        addCustomLinksBtn.on("click", addCustomLink);
        
        delCustomLinksBtn = $(".admin-custom-link-delete");
        delCustomLinksBtn.on("click", delCustomLink);
        
        customLinksPageSaveBtn = $(".save-custom-links");
        customLinksPageSaveBtn.on("click", saveCustomLinks);
        
        initDraggable();
	};
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);